<template>
  <div
    class="type-scale-n1 h-16 w-full px-4 flex items-start justify-center hover:bg-gray-20 select-none flex-col whitespace-nowrap"
    :class="active && 'text-primary font-bold'"
    @click="$emit('click')"
  >
    <slot />
    <div class="type-scale-n4 text-gray-70 font-normal" v-if="$slots.secondary">
      <slot name="secondary" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppListItem',

  props: {
    active: Boolean
  }
}
</script>
